<div class="field" [formGroup]="formGroup">
  <input [id]="field.name" [formControlName]="field.name" [matDatepicker]="datepicker" (click)="datepicker.open()" [min]="min" [max]="max" placeholder="дд.мм.гггг" (dateChange)="onChange($event)">
  <mat-datepicker #datepicker></mat-datepicker>
</div>
